module.exports = __webpack_public_path__ + "static/img/KR@2x.dbfadd4d.jpg";